import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAdminNavigation from '../utils/useAdminNavigation';

export default function AdminAttention() {
  const { pathname } = useLocation();
  const counts = useAdminNavigation(Boolean(localStorage.getItem('authToken')), pathname);
  return <section className="admin-attention" aria-label="موارد نیازمند رسیدگی">{[
    ['درخواست‌های ریالی', '/AdminWalletRequests_page', counts.wallet],
    ['درخواست‌های تحویل طلا', '/admin-gold-requests_page', counts.gold],
    ['پیام‌های خوانده‌نشده', '/admin-chat_page', counts.chat],
    ['پیگیری‌های عقب‌افتاده', '/admin-crm_page?tab=tasks&overdue=1', counts.overdue],
  ].map(([label, to, count]) => <Link key={to} to={to}><span>{label}</span><strong>{count == null ? '—' : Number(count).toLocaleString('fa-IR')}</strong></Link>)}</section>;
}
